module.exports = "<li> <div [routerLink]=\"link\" [ngClass]=\"{'active': active, 'selected': selected}\" (click)=\"this.selected=true\" class=\"title\"> <span *ngIf=\"translation\" [jhiTranslate]=\"translation\"> {{title}} </span> <span *ngIf=\"!translation\"> {{title}} </span> </div> <ng-content *ngIf=\"active\"></ng-content> </li> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/generic/navigation-menu/navigation-menu-element/navigation-menu-element.component.html
// module id = 216
// module chunks = 0